import { Router } from '@angular/router';
import { Cache } from 'aws-amplify';
import { isRetailPortal, isRetailPortalPathAllowed } from '../_config/portal-view';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var PortalViewGuardService = /** @class */ (function () {
    function PortalViewGuardService(router) {
        this.router = router;
    }
    PortalViewGuardService.prototype.canActivate = function (next, state) {
        var userAttr = Cache.getItem('userAttr');
        if (isRetailPortal(userAttr) && !isRetailPortalPathAllowed(state.url)) {
            this.router.navigate(['/dashboard']);
            return false;
        }
        return true;
    };
    PortalViewGuardService.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    PortalViewGuardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PortalViewGuardService_Factory() { return new PortalViewGuardService(i0.ɵɵinject(i1.Router)); }, token: PortalViewGuardService, providedIn: "root" });
    return PortalViewGuardService;
}());
export { PortalViewGuardService };
